import type { Node } from 'react'
import React from 'react'
import { colors } from 'shared/assets/styles'
import { SmallText } from 'app/common/typography'
import Tooltip from 'rc-tooltip'

type Props = {
    label: string,
    placement?: string,
    delay?: 0.3,
    children: Node
}

const TooltipPop = (props: Props) => {
    const { label, placement = 'top', delay = 0.3, children } = props
    return (
        <Tooltip
            placement={placement}
            mouseEnterDelay={delay}
            overlay={<SmallText color={colors.text}>{label}</SmallText>}
            arrowContent={<div className="rc-tooltip-arrow-inner" />}>
            {children}
        </Tooltip>
    )
}

export { TooltipPop }
